import { j as e } from "./jsx-runtime.DGlMoOmv.js";
import { useFormContext as v } from "react-hook-form";
import { d as C, e as F, f as N, b as I, g as y } from "./Form.LdCd9gH2.js";
import { c as f } from "./index.CxSWpsOB.js";
import * as g from "react";
import { B as p } from "./Button.Ccj-dDdM.js";
import { I as M } from "./Input.D9O4R5sO.js";
const R = (t, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref: a, ...t, children: /* @__PURE__ */ e.jsx("path", { fill: "currentColor", d: "M14 7.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1 0-1h11a.5.5 0 0 1 .5.5Z" }) }), S = g.forwardRef(R), b = (t, a) => /* @__PURE__ */ e.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref: a, ...t, children: /* @__PURE__ */ e.jsx("path", { fill: "currentColor", d: "M7.5 13.5a.5.5 0 0 0 1 0v-5h5a.5.5 0 0 0 0-1h-5v-5a.5.5 0 0 0-1 0v5h-5a.5.5 0 1 0 0 1h5v5Z" }) }), B = g.forwardRef(b), j = g.forwardRef(({
  testId: t = "counter-input",
  className: a,
  disabled: i,
  readOnly: x,
  value: n,
  onValueChange: h,
  fullWidth: s,
  allowFloat: m = !1,
  ...o
}, d) => {
  const r = (m ? o.min : Math.floor(o.min ?? 0)) ?? 0, c = (m ? o.max : Math.floor(o.max ?? 1 / 0)) ?? 1 / 0, l = (u) => {
    let w = m ? parseFloat(u) : parseInt(u, 10);
    isNaN(w) || w < r ? w = r : w > c && (w = c), h?.(w);
  };
  return /* @__PURE__ */ e.jsxs("div", { ref: d, className: f("tw-flex tw-gap-4 tw-h-24", {
    "tw-pointer-events-none": x,
    "tw-w-full tw-h-32": s
  }, a), children: [
    /* @__PURE__ */ e.jsx(p, { appearance: "white", variant: "outline-1", className: f("tw-h-full tw-w-24 tw-p-0", {
      "tw-w-full tw-flex-1 tw-max-w-[25%]": s
    }), onClick: () => l(String((n ?? 0) - 1)), disabled: i || n === r, testId: t ? `${t}-decrement` : void 0, children: /* @__PURE__ */ e.jsx(S, {}) }),
    /* @__PURE__ */ e.jsx(M, { className: f("tw-text-center tw-py-0 tw-px-2 tw-h-full tw-w-40", {
      "tw-flex-1 tw-w-full": s
    }), type: "number", disabled: i, readOnly: x, fullWidth: s, ...o, value: String(n), onChange: (u) => l(u.target.value), testId: t }),
    /* @__PURE__ */ e.jsx(p, { appearance: "white", variant: "outline-1", className: f("tw-h-full tw-w-24 tw-p-0", {
      "tw-w-full tw-flex-1 tw-max-w-[25%]": s
    }), onClick: () => l(String((n ?? 0) + 1)), disabled: i || n === c, testId: t ? `${t}-increment` : void 0, children: /* @__PURE__ */ e.jsx(B, {}) })
  ] });
});
j.displayName = "CounterInput";
const $ = ({
  prefix: t,
  suffix: a,
  testId: i,
  className: x,
  inputClassName: n,
  label: h,
  subcopy: s,
  note: m,
  name: o,
  fullWidth: d = !1,
  ...r
}) => {
  const {
    control: c
  } = v();
  return /* @__PURE__ */ e.jsx(C, { control: c, name: o, render: ({
    field: l
  }) => /* @__PURE__ */ e.jsxs(F, { disabled: r.disabled, readOnly: r.readOnly, className: f({
    "tw-w-full tw-flex-1": d
  }, x), children: [
    !!h && /* @__PURE__ */ e.jsx(N, { subcopy: s, required: r.required, children: h }),
    /* @__PURE__ */ e.jsx(I, { forwardErrorMsg: !0, children: /* @__PURE__ */ e.jsx(j, { className: n, prefix: t, suffix: a, testId: i, fullWidth: d, ...r, value: l.value, onValueChange: l.onChange }) }),
    /* @__PURE__ */ e.jsx(y, { children: m })
  ] }) });
};
$.displayName = "CounterInputField";
export {
  j as C,
  $ as a
};
//# sourceMappingURL=CounterInputField.DNhKAHAQ.js.map
